export default {
	loader: false,
	error: false,
	name: ""
}